import { writable } from 'svelte/store';

export const pedTotalscore = writable(0);

export const pedPulsescore = writable(0);
export const pedTempscore = writable(0);
export const pedRRscore = writable(0);
export const pedRespscore = writable();
export const pedSatscore = writable(0);
export const pedAVPUscore = writable(0);
export const pedGutscore = writable(0);
export const pedOtherscore = writable(0);

